module.exports = __webpack_public_path__ + "img/logo.a2fe0ed8.png";